import gql from 'graphql-tag';

const UPDATE_CONTRACT_MUTATION = gql`
  mutation(
      $contractId: Int!
      $situationDate: Date!,
      $futureValuePremiumFreeFiscal: Decimal!,
      $futureValuePremiumPayingFiscal: Decimal!) {  
    updateContract(
      contractId: $contractId
      futureValuePremiumFreeFiscal: $futureValuePremiumFreeFiscal,
      futureValuePremiumPayingFiscal: $futureValuePremiumPayingFiscal,
      situationDate: $situationDate
    ){
      endAge
      contractId
      canBeUpdatedByUser
      contractType {
        contractTypeId
        name
      }   
      contractNumber
      insuranceCompany {
        name
      }
      endDate
      futureValuePremiumFreeFiscal
      futureValuePremiumPayingFiscal
      situationDate
    }
  }
`;

export default UPDATE_CONTRACT_MUTATION;
